import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const LOGO_EP3D = "https://customer-assets.emergentagent.com/job_89a536dc-36dd-4821-ba4f-a6c069ebdb60/artifacts/u7v2hasx_Logotipo.png";

export default function BoxInfo() {
  const { lot } = useParams();
  const [data, setData] = useState(null);
  const [err, setErr] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await axios.get(`${API}/public/box-labels/by-lot/${encodeURIComponent(lot)}`);
        if (!cancelled) setData(res.data);
      } catch (e) {
        if (!cancelled) setErr(e?.response?.data?.detail || "Lote não encontrado");
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => { cancelled = true; };
  }, [lot]);

  const SHIFT = { morning: "Manhã", afternoon: "Tarde", night: "Noite" };

  return (
    <div style={{ minHeight: "100vh", background: "linear-gradient(180deg, #f8fafc 0%, #e2e8f0 100%)", padding: "20px 16px", fontFamily: "'Segoe UI', system-ui, sans-serif", color: "#0f172a" }}>
      <div style={{ maxWidth: 500, margin: "0 auto", background: "#fff", borderRadius: 12, boxShadow: "0 10px 40px rgba(15,23,42,0.15)", overflow: "hidden" }}>
        <div style={{ background: "#0f172a", color: "#fff", padding: "20px 16px", display: "flex", alignItems: "center", gap: 12 }}>
          <img src={LOGO_EP3D} alt="EP3D" style={{ height: 54 }} />
          <div>
            <div style={{ fontSize: 20, fontWeight: 900, letterSpacing: -0.5 }}>EP3D</div>
            <div style={{ fontSize: 11, color: "#facc15", textTransform: "uppercase", fontWeight: 700, letterSpacing: 1 }}>Etiqueta de Caixa</div>
          </div>
        </div>

        {loading && <div style={{ padding: 40, textAlign: "center", color: "#64748b" }}>A carregar lote {lot}...</div>}

        {err && !loading && (
          <div style={{ padding: 24 }}>
            <div style={{ background: "#fef2f2", border: "2px solid #fca5a5", borderRadius: 8, padding: 16, color: "#991b1b" }}>
              <div style={{ fontWeight: 700, marginBottom: 4 }}>❌ Lote não encontrado</div>
              <div style={{ fontSize: 13 }}>Lote pesquisado: <code>{lot}</code></div>
              <div style={{ fontSize: 12, marginTop: 8 }}>{err}</div>
            </div>
          </div>
        )}

        {data && !loading && (
          <div style={{ padding: "20px 18px" }}>
            <div style={{ background: "#0f172a", color: "#facc15", padding: "10px 14px", borderRadius: 6, fontFamily: "'Courier New', monospace", fontWeight: 700, textAlign: "center", letterSpacing: 1, fontSize: 16, marginBottom: 16 }}>
              {data.lot_number}
            </div>

            <Row label="Peça" value={data.part_code} highlight />
            <Row label="Descrição" value={data.part_description} />
            <Row label="Cliente" value={data.client_name || "-"} />
            <Row label="Ordem de Fabrico" value={data.order_code} />
            <Row label="Caixa nº" value={`#${data.box_number}`} />

            <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 10, margin: "14px 0", padding: "10px 0", borderTop: "1px solid #e2e8f0", borderBottom: "1px solid #e2e8f0" }}>
              <Stat lbl="Quantidade" val={`${(data.quantity || 0).toLocaleString("pt-PT")} un`} color="#f97316" />
              <Stat lbl="Peso bruto" val={`${(data.weight_kg || 0).toFixed(2)} kg`} color="#1e40af" />
            </div>

            <Row label="Operador" value={data.operator_code || "-"} />
            <Row label="Turno" value={SHIFT[data.shift] || data.shift || "-"} />
            <Row label="Produzido em" value={data.created_at ? new Date(data.created_at).toLocaleString("pt-PT") : "-"} />

            <div style={{ marginTop: 20, padding: 12, background: "#f1f5f9", borderRadius: 6, fontSize: 11, color: "#475569", textAlign: "center" }}>
              📋 Dados oficiais de produção EP3D · Rastreabilidade ISO 9001
            </div>
          </div>
        )}
      </div>
    </div>
  );
}

function Row({ label, value, highlight }) {
  return (
    <div style={{ display: "flex", justifyContent: "space-between", padding: "8px 0", borderBottom: "1px dotted #cbd5e1", gap: 10, alignItems: "baseline" }}>
      <span style={{ color: "#64748b", fontSize: 11, textTransform: "uppercase", fontWeight: 700, letterSpacing: 0.3 }}>{label}</span>
      <span style={{ color: highlight ? "#f97316" : "#0f172a", fontWeight: highlight ? 800 : 600, fontSize: highlight ? 18 : 13, textAlign: "right" }}>{value}</span>
    </div>
  );
}

function Stat({ lbl, val, color }) {
  return (
    <div style={{ textAlign: "center", padding: 6 }}>
      <div style={{ fontSize: 10, color: "#64748b", textTransform: "uppercase", fontWeight: 700, letterSpacing: 0.5 }}>{lbl}</div>
      <div style={{ fontSize: 18, fontWeight: 800, color, marginTop: 2 }}>{val}</div>
    </div>
  );
}
